<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <!-- Transparent background -->
        <path d="M0 0h24v24H0z" fill="none" />
        <!-- Pencil/Edit icon -->
        <path
            d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zm17.71-10.21a1.001 1.001 0 0 0 0-1.41l-2.34-2.34a1.001 1.001 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            fill="currentColor"
        />
    </svg>
</template>
